// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previous-newsletter {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.previous-newsletter-container {
  flex: 1 1;
  margin-top: 2em;
  margin-inline: 2em;
  padding: 2em;
  border-radius: 1em;
  background-color: #fff;
}
.previous-newsletter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.previous-newsletter-title {
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0;
  color: #333;
}
.previous-newsletter-form {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.previous-newsletter-form-layout {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.previous-newsletter .form-row {
  display: flex;
  gap: 1.5rem;
  width: 100%;
}
@media (max-width: 768px) {
  .previous-newsletter .form-row {
    flex-direction: column;
  }
}
.previous-newsletter .form-row .form-input {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 0.5rem;
}
.previous-newsletter .form-row .form-input label {
  font-weight: 600;
  color: #555;
  font-size: 0.9rem;
}
.previous-newsletter .form-row .form-input .form-control {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 0.375rem;
  font-size: 1rem;
}
.previous-newsletter .form-row .form-input .form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.previous-newsletter .newsletter-radio-group .form-radio-group {
  display: flex;
  gap: 2rem;
  margin-top: 0.5rem;
}
.previous-newsletter .newsletter-radio-group .form-radio-group .form-check {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.previous-newsletter .retiree-portal-toggle {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.previous-newsletter .retiree-portal-toggle .toggle-control {
  display: flex;
  align-items: center;
}
.previous-newsletter .retiree-portal-toggle .toggle-control .custom-switch .form-check-input {
  width: 3rem;
  height: 1.5rem;
  margin-right: 0.75rem;
}
.previous-newsletter .retiree-portal-toggle .toggle-control .custom-switch .form-check-label {
  font-weight: 600;
  color: #555;
  font-size: 0.9rem;
}
.previous-newsletter .form-action-group {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #eee;
}
.previous-newsletter .form-action-group .form-action {
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
}
.previous-newsletter .form-action-group .form-action.form-action-primary {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}
.previous-newsletter .form-action-group .form-action.form-action-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}
.previous-newsletter .form-action-group .form-action.form-action-primary:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
}
.previous-newsletter .form-action-group .form-action:not(.form-action-primary):hover {
  background-color: #f8f9fa;
}
.previous-newsletter .form-custom-switch .form-check-input {
  width: 3rem;
  height: 1.5rem;
  border-radius: 1rem;
  background-color: #ccc;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}
.previous-newsletter .form-custom-switch .form-check-input:checked {
  background-color: #28a745;
}
.previous-newsletter .form-custom-switch .form-check-input:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}
.previous-newsletter .form-custom-switch .form-check-label {
  margin-left: 0.5rem;
  font-weight: 600;
  color: #555;
}

.file-input-container .file-input {
  border: 2px dashed #ddd;
  border-radius: 0.375rem;
  padding: 1.5rem;
  text-align: center;
  background-color: #fafafa;
  transition: all 0.3s ease;
}
.file-input-container .file-input:hover {
  border-color: #007bff;
  background-color: #f0f8ff;
}
.file-input-container .file-input.dragover {
  border-color: #007bff;
  background-color: #e3f2fd;
}
.file-input-container .file-preview {
  margin-top: 1rem;
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 0.375rem;
  border: 1px solid #ddd;
}
.file-input-container .file-preview .file-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #555;
}`, "",{"version":3,"sources":["webpack://./src/components/views/previousNewsletter/previousNewsletterForm/previousNewsletterForm.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AACF;AACE;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AACJ;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAFJ;AAII;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAFN;AAME;EACE,aAAA;EACA,WAAA;EACA,WAAA;AAJJ;AAMI;EALF;IAMI,sBAAA;EAHJ;AACF;AAKI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAHN;AAKM;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AAHR;AAMM;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AAJR;AAMQ;EACE,qBAAA;EACA,gDAAA;AAJV;AAWI;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AATN;AAWM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AATR;AAcE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAZJ;AAcI;EACE,aAAA;EACA,mBAAA;AAZN;AAeQ;EACE,WAAA;EACA,cAAA;EACA,qBAAA;AAbV;AAgBQ;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AAdV;AAoBE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAlBJ;AAoBI;EACE,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;AAlBN;AAoBM;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;AAlBR;AAoBQ;EACE,yBAAA;EACA,qBAAA;AAlBV;AAqBQ;EACE,yBAAA;EACA,qBAAA;AAnBV;AAwBQ;EACE,yBAAA;AAtBV;AA6BI;EACE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AA3BN;AA6BM;EACE,yBAAA;AA3BR;AA8BM;EACE,gDAAA;AA5BR;AAgCI;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;AA9BN;;AAqCE;EACE,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAlCJ;AAoCI;EACE,qBAAA;EACA,yBAAA;AAlCN;AAqCI;EACE,qBAAA;EACA,yBAAA;AAnCN;AAuCE;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AArCJ;AAuCI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;AArCN","sourcesContent":[".previous-newsletter {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1;\n  height: 100%;\n  box-sizing: border-box;\n  overflow: scroll;\n\n  &-container {\n    flex: 1;\n    margin-top: 2em;\n    margin-inline: 2em;\n    padding: 2em;\n    border-radius: 1em;\n    background-color: #fff;\n  }\n\n  &-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n  }\n\n  &-title {\n    font-size: 1.75rem;\n    font-weight: 600;\n    margin: 0;\n    color: #333;\n  }\n\n  &-form {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n\n    &-layout {\n      display: flex;\n      flex-direction: column;\n      gap: 1.5rem;\n    }\n  }\n\n  .form-row {\n    display: flex;\n    gap: 1.5rem;\n    width: 100%;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n\n    .form-input {\n      display: flex;\n      flex-direction: column;\n      flex: 1;\n      gap: 0.5rem;\n\n      label {\n        font-weight: 600;\n        color: #555;\n        font-size: 0.9rem;\n      }\n\n      .form-control {\n        padding: 0.75rem;\n        border: 1px solid #ddd;\n        border-radius: 0.375rem;\n        font-size: 1rem;\n\n        &:focus {\n          border-color: #007bff;\n          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n        }\n      }\n    }\n  }\n\n  .newsletter-radio-group {\n    .form-radio-group {\n      display: flex;\n      gap: 2rem;\n      margin-top: 0.5rem;\n\n      .form-check {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n      }\n    }\n  }\n\n  .retiree-portal-toggle {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n\n    .toggle-control {\n      display: flex;\n      align-items: center;\n\n      .custom-switch {\n        .form-check-input {\n          width: 3rem;\n          height: 1.5rem;\n          margin-right: 0.75rem;\n        }\n\n        .form-check-label {\n          font-weight: 600;\n          color: #555;\n          font-size: 0.9rem;\n        }\n      }\n    }\n  }\n\n  .form-action-group {\n    display: flex;\n    gap: 1rem;\n    justify-content: flex-end;\n    margin-top: 2rem;\n    padding-top: 1.5rem;\n    border-top: 1px solid #eee;\n\n    .form-action {\n      padding: 0.75rem 1.5rem;\n      font-weight: 600;\n      border-radius: 0.375rem;\n      transition: all 0.2s ease;\n\n      &.form-action-primary {\n        background-color: #007bff;\n        border-color: #007bff;\n        color: white;\n\n        &:hover {\n          background-color: #0056b3;\n          border-color: #0056b3;\n        }\n\n        &:disabled {\n          background-color: #6c757d;\n          border-color: #6c757d;\n        }\n      }\n\n      &:not(.form-action-primary) {\n        &:hover {\n          background-color: #f8f9fa;\n        }\n      }\n    }\n  }\n\n  .form-custom-switch {\n    .form-check-input {\n      width: 3rem;\n      height: 1.5rem;\n      border-radius: 1rem;\n      background-color: #ccc;\n      border: none;\n      cursor: pointer;\n      transition: all 0.3s ease;\n\n      &:checked {\n        background-color: #28a745;\n      }\n\n      &:focus {\n        box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);\n      }\n    }\n\n    .form-check-label {\n      margin-left: 0.5rem;\n      font-weight: 600;\n      color: #555;\n    }\n  }\n}\n\n// File input styling\n.file-input-container {\n  .file-input {\n    border: 2px dashed #ddd;\n    border-radius: 0.375rem;\n    padding: 1.5rem;\n    text-align: center;\n    background-color: #fafafa;\n    transition: all 0.3s ease;\n\n    &:hover {\n      border-color: #007bff;\n      background-color: #f0f8ff;\n    }\n\n    &.dragover {\n      border-color: #007bff;\n      background-color: #e3f2fd;\n    }\n  }\n\n  .file-preview {\n    margin-top: 1rem;\n    padding: 0.75rem;\n    background-color: #f8f9fa;\n    border-radius: 0.375rem;\n    border: 1px solid #ddd;\n\n    .file-info {\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      font-size: 0.9rem;\n      color: #555;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
